document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-quick-add]');
  if (!btn || btn.disabled) return;
  e.preventDefault();

  var variantId = btn.getAttribute('data-variant-id');
  var originalText = btn.getAttribute('data-original-text') || btn.textContent;
  btn.setAttribute('data-original-text', originalText);
  btn.disabled = true;
  btn.textContent = '...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then(function (res) {
      if (!res.ok) throw new Error('add failed');
      window.location.href = '/checkout';
    })
    .catch(function () {
      btn.textContent = 'Erreur';
      setTimeout(function () {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1800);
    });
});
